import { Component, ViewChild, Injector, Output, EventEmitter, OnInit, ElementRef } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { debounceTime, finalize, switchMap } from 'rxjs/operators';
import { AccountGroupsServiceProxy, CreateOrEditAccountGroupDto } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DateTime } from 'luxon';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';

@Component({
    selector: 'createOrEditAccountGroupModal',
    templateUrl: './create-or-edit-accountGroup-modal.component.html',
    standalone: false,
})
export class CreateOrEditAccountGroupModalComponent extends AppComponentBase implements OnInit {
    @ViewChild('createOrEditModal', { static: true }) modal: ModalDirective;

    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    saving = false;

    accountGroup: CreateOrEditAccountGroupDto = new CreateOrEditAccountGroupDto();

    constructor(
        injector: Injector,
        private _accountGroupsServiceProxy: AccountGroupsServiceProxy,
        private _dateTimeService: DateTimeService,
    ) {
        super(injector);
    }

    ngOnInit(): void {}

    show(accountGroupId?: number): void {
        if (!accountGroupId) {
            this.accountGroup = new CreateOrEditAccountGroupDto();
            this.accountGroup.id = accountGroupId;

            this.active = true;
            this.modal.show();
        } else {
            this._accountGroupsServiceProxy.getAccountGroupForEdit(accountGroupId).subscribe((result) => {
                this.accountGroup = result.accountGroup;

                this.active = true;
                this.modal.show();
            });
        }
    }

    save(): void {
        this.saving = true;

        this._accountGroupsServiceProxy
            .createOrEdit(this.accountGroup)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe(() => {
                this.notify.info(this.l('SavedSuccessfully'));
                this.close();
                this.modalSave.emit(null);
            });
    }

    close(): void {
        this.active = false;
        this.modal.hide();
    }
}
